import React, { useEffect } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
// import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { fetchScreens } from "../../Actions/screensActions";
import ScreensTable from "./Screens/screensTable";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </Typography>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        width: '100%',
    },
}));

const Screens = ({ fetchScreens, screens }) => {

    const classes = useStyles();
    const theme = useTheme();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };


    useEffect(() => {
        fetchScreens();
    }, []);
    
    return (
        // <div>
            // {/* <ScreensTable screens={screens}/> */}


        // </div>
        <div className={classes.root}>
            {/* <AppBar position="static" color="default">
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                    aria-label="full width tabs example"
                >
                    <Tab label="Screens" {...a11yProps(0)} />
                    <Tab label="Apps" {...a11yProps(1)} />
                    <Tab label="Web" {...a11yProps(2)} />
                </Tabs>
            </AppBar>
            <TabPanel value={value} index={0} dir={theme.direction}>
                
            </TabPanel>
            <TabPanel value={value} index={1} dir={theme.direction}>
                No Application data
            </TabPanel>
            <TabPanel value={value} index={2} dir={theme.direction}>
                No Web data
            </TabPanel> */}
            <ScreensTable screens={screens}/>
        </div>
    )
}

const mapStateToProps = (state) => {

    return {
        screens: state.screens
    }
}

export default connect(mapStateToProps, { fetchScreens })(Screens);
